// events
export const stepPayloadDefaults = {
  page_section: 'Tests',
  dossier_name: 'Hypotheek',
  dossier_theme: 'Geld & Verzekering',
  page_type: 'Advies',
  form_type: 'Advies',
};

const maxMortgageStepPayloadMap = {
  inkomen: {
    page_name: 'Hypotheek:Advies:Maximaal Lenen V2:Inkomen',
    form_step: '1',
    form_step_name: 'Inkomen',
    form_status: ['start'],
    form_name: 'Maximaal Lenen V2',
  },
  segmentatie: {
    page_name: 'Hypotheek:Advies:Maximaal Lenen V2:Segmentatie',
    form_step: '2',
    form_step_name: 'Segmentatie',
    form_status: ['mid', 'success'],
    form_name: 'Maximaal Lenen V2',
  },
  vermogen: {
    page_name: 'Hypotheek:Advies:Maximaal Lenen V2:Eigen Middelen',
    form_step: '3',
    form_step_name: 'Eigen Middelen',
    form_status: ['mid', 'success'],
    form_name: 'Maximaal Lenen V2',
  },
  woning: {
    page_name: 'Hypotheek:Advies:Maximaal Lenen V2:Woning',
    form_step: '4',
    form_step_name: 'Woning',
    form_status: ['mid', 'success'],
    form_name: 'Maximaal Lenen V2',
  },
  hypotheek: {
    page_name: 'Hypotheek:Advies:Maximaal Lenen V2:Hypotheek',
    form_step: '5',
    form_step_name: 'Hypotheek',
    form_status: ['mid', 'success'],
    form_name: 'Maximaal Lenen V2',
  },
  queue: {
    page_name: 'Hypotheek:Advies:Maximaal Lenen V2:Uitrekenen',
    form_step: '6',
    form_step_name: 'Uitrekenen',
    form_status: ['mid', 'success'],
    form_name: 'Maximaal Lenen V2',
  },
  feedback: {
    page_name: 'Hypotheek:Advies:Maximaal Lenen V2:Feedback',
    form_step: '7',
    form_step_name: 'Feedback',
    form_status: ['end', 'success'],
    form_name: 'Maximaal Lenen V2',
  },
};

const refinanceStepPayloadMap = {
  hypotheek: {
    page_name: 'Hypotheek:Advies:Oversluiten:Hypotheek',
    form_step: '1',
    form_step_name: 'Hypotheek',
    form_status: ['start'],
    form_name: 'Oversluiten',
  },
  woning: {
    page_name: 'Hypotheek:Advies:Oversluiten:Woning',
    form_step: '2',
    form_step_name: 'Woning',
    form_status: ['mid', 'success'],
    form_name: 'Oversluiten',
  },
  leningdelen: {
    page_name: 'Hypotheek:Advies:Oversluiten:Leningdelen',
    form_step: '3',
    form_step_name: 'Leningdelen',
    form_status: ['mid', 'success'],
    form_name: 'Oversluiten',
  },
  inkomen: {
    page_name: 'Hypotheek:Advies:Oversluiten:Inkomen',
    form_step: '4',
    form_step_name: 'Inkomen',
    form_status: ['mid', 'success'],
    form_name: 'Oversluiten',
  },
  renteverwachting: {
    page_name: 'Hypotheek:Advies:Oversluiten:Renteverwachting',
    form_step: '5',
    form_step_name: 'Renteverwachting',
    form_status: ['mid', 'success'],
    form_name: 'Oversluiten',
  },
  queue: {
    page_name: 'Hypotheek:Advies:Oversluiten:Uitrekenen',
    form_step: '6',
    form_step_name: 'Uitrekenen',
    form_status: ['mid', 'success'],
    form_name: 'Oversluiten',
  },
  feedback: {
    page_name: 'Hypotheek:Advies:Oversluiten:Feedback',
    form_step: '7',
    form_step_name: 'Feedback',
    form_status: ['end', 'success'],
    form_name: 'Oversluiten',
  },
};

const monthlyChargePayloadMap = {
  'form': {
    page_name: 'Hypotheek:Advies:Maandlasten:Je gegevens',
    form_name: 'Maandlasten',
    form_step: '1',
    form_step_name: 'Je gegevens',
    form_status: ['start'],
  },
  'feedback': {
    page_name: 'Hypotheek:Advies:Maandlasten:Resultaten',
    form_name: 'Maandlasten',
    form_step: '2',
    form_step_name: 'Resultaten',
    form_status: ['mid', 'success'],
  },
  'interest-raise': {
    page_name: 'Hypotheek:Advies:Maandlasten:Wat als de rente stijgt',
    form_name: 'Maandlasten',
    form_step: '2a',
    form_step_name: 'Wat als de rente stijgt',
    form_status: [],
  },
};

const vriendenhypotheekStepPayloadMap = {
  form: {
    page_name: 'Hypotheek:Advies:Vriendenhypotheek:Huishoudens',
    form_step: '1',
    form_step_name: 'Huishoudens',
    form_status: ['start'],
    form_name: 'VH Berekenen',
  },
  result: {
    page_name: 'Hypotheek:Advies:Vriendenhypotheek:Bedankt',
    form_step: '2',
    form_step_name: 'Bedankt',
    form_status: ['end', 'success'],
    form_name: 'VH Berekenen',
  },
};

// VH Appointment tracking config
export const vriendenhypotheekAppointmentConfig = {
  defaults: {
    dossier_name: 'Hypotheek',
    dossier_theme: 'Geld & Verzekering',
    page_type: 'Contact',
    form_type: 'Contact',
    form_name: 'VH Afspraak Maken',
  },
  steps: {
    loaded: {
      page_name: 'Hypotheek:Contact:Vriendenhypotheek:Gegevens',
      form_step: '1',
      form_step_name: 'Gegevens',
      form_status: ['start'],
    },
    success: {
      page_name: 'Hypotheek:Contact:Vriendenhypotheek:Bedankt',
      form_step: '2',
      form_step_name: 'Bedankt',
      form_status: ['end', 'success'],
    },
  },
};

const toolStepPayloadMap = {
  max_mortgage: maxMortgageStepPayloadMap,
  refinance: refinanceStepPayloadMap,
  monthly_charge: monthlyChargePayloadMap,
  vriendenhypotheek: vriendenhypotheekStepPayloadMap,
};

/**
 * Returns specific step payload
 *
 * @param {Object} event payload with tool & step property
 * @return {Object} step payload
 */
export function getStepPayload({ toolName, to, step }) {
  // Resolve step name from object or string
  const stepName = to?.name || to || step;
  const payload = toolStepPayloadMap[toolName]?.[stepName];

  if (!payload)
    return null;

  return { ...payload, ...stepPayloadDefaults };
}
